module.exports = __webpack_public_path__ + "img/吃瓜.3414ce88.png";